/**
 * VistoeraTASK-00364 — pure decision logic extracted from `ProvidersPage.
 * tsx`'s `statusCell` so it is unit-testable (Node/`tsx`) without pulling in
 * antd/CSS module-level imports.
 *
 * Root cause this fixes: Admin's "运行状态" cell used to render the raw
 * Worker heartbeat badge (`WorkerStatusBadge`) for ANY LOCAL_WORKER mapping
 * that had a real `worker_id` + `worker_display_status`, regardless of the
 * SAME canonical `runtime_status` Tenant Canvas discovery already computes
 * (`provider_option_service._mapping_availability`). A Worker that is
 * online but whose mapping has no AI Harness execution route (DeepSeek/
 * Grok text: `runtime_status.code === 'adapter_missing'`) still showed a
 * plain green "在线" — the exact ADMIN=ONLINE+ENABLED vs CANVAS=UNAVAILABLE
 * drift this task fixes. The nuanced online/busy/draining Worker badge is
 * now shown ONLY once the canonical resolver already agrees the option is
 * selectable (`runtime_status.available === true`); every other case must
 * defer to `runtime_status`'s own honest label+tone.
 */

export type CanonicalRuntimeStatus = {
  code: string
  label: string
  tone: 'success' | 'info' | 'warning' | 'danger' | 'neutral' | string
  available: boolean
} | null | undefined

export type LocalWorkerStatusInput = {
  worker_id?: string | null
  worker_display_status?: string | null
  runtime_status?: CanonicalRuntimeStatus
}

/**
 * `true` only when a real Worker is bound+resolved AND the canonical
 * resolver already says this execution option is selectable — the single
 * gate for whether the Admin "运行状态" cell may show the raw Worker
 * heartbeat badge instead of the canonical reason Tag.
 */
export function shouldShowWorkerHeartbeatBadge(m: LocalWorkerStatusInput): boolean {
  return Boolean(m.worker_id) && Boolean(m.worker_display_status) && m.runtime_status?.available === true
}
